import { memo, useRef } from 'react';
import { Group, Rect, Text } from 'react-konva';

import Konva from 'konva';

interface RoomRectProps extends Konva.RectConfig {
  selectedShapeName?: string;
  rectProps?: Konva.RectConfig;
  rectAttrs?: Konva.RectConfig;
  textAttrs?: Konva.TextConfig;
}

export const RoomRect: React.FC<RoomRectProps> = ({
  selectedShapeName = '',
  rectProps,
  rectAttrs,
  textAttrs,
  ...props
}) => {
  return (
    <>
      <Group draggable className={selectedShapeName} {...props}>
        <Rect {...rectAttrs} strokeScaleEnabled={false} />
        <Text {...textAttrs} />
      </Group>
    </>
  );
};

export default memo(RoomRect);
